export default {
  // 右键菜单项
  viewDetails: "查看详情",
  viewDetailsShortcut: "查看详情(ctrl+e)",
  noteNode: "备注节点",
  noteNodeShortcut: "备注节点(alt+v/⌥+v)",
  joinMonitoring: "加入监控",
  joinMonitoringShortcut: "加入监控(ctrl+m)",
  joinSurvey: "加入调证",
  ordinarySurvey: "普通调证",
  keySurvey: "重点调证",
  joinDashboard: "加入看板",
  transactionDashboard: "交易数据看板",
  balanceDashboard: "余额数据看板",
  aiModel: "AI模型",
  firstFeesModel: "首笔手续费模型",
  relatedFeesModel: "关联手续费模型",
  tornadoModel: "龙卷风模型",
  newCanvas: "新建画布",
  newCanvasShortcut: "新建画布(alt+g/⌥+g)",
  copyAddress: "复制地址",
  copyAddressShortcut: "复制地址(ctrl+c)",

  // 提示消息
  noteSuccess: "备注成功",
  noteFailed: "备注失败,请刷新重试!",
  addedToSurvey: "已加入调证",
  notSupportMonitoring: "该地址暂不支持地址监控!",
  notSupportModel: "该地址暂不支持模型验证!",
  submitSuccess: "提交成功,等待验证结果",
};
